import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import classes from "../Accordion.module.css";
import Icons from "../../../../resources/icons/Icons";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const SummaryAssignedAllocations = (props) => {
  // prev
  //const usersSite = useSelector((state) => state.user.selectedSite?.userSites);
  const usersSite = props?.selectedSite?.userSites;
  const assignedCarUserTokens = props?.occupiedToken?.carUserTokens;

  const getNameById = (userId) => {
    const user = usersSite?.find((user) => user?.userId === userId)?.user;
    if (user) {
      return `${user?.firstName} ${user?.lastName}`;
    }
  };

  const handleDeleteToken = () => {
    props.handleDeleteTokenByIndex(props?.index - 1);
  };

  return (
    <div className={classes.cardContainer}>
      <Accordion expanded={true} className={classes.accordion}>
        <AccordionSummary
          expandIcon={props.isShowClearIcon ? <ClearIcon onClick={handleDeleteToken} /> : null}
          className={classes.accordionFobSummary}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <img src={Icons.PARKING_ALLOCATION} />
          <div className={classes.summaryText}>
            {props.index} {props?.occupiedToken?.displayValue}
          </div>
          {props?.occupiedToken?.isBillingEnabled && <img src={Icons.PAYING} />}
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          {props.fob && (
            <div className={classes.tokenDetails}>
              <span>FOB</span>
              <span>{props.fob}</span>
            </div>
          )}
          {assignedCarUserTokens &&
            assignedCarUserTokens.map((carUserToken) => {
              if (carUserToken?.fob && props.fob != carUserToken?.fob) {
                return (
                  <div key={carUserToken?.id} className={classes.tokenDetails}>
                    <span>FOB</span>
                    <span>{carUserToken?.fob}</span>
                  </div>
                );
              } else if (!carUserToken?.fob) {
                let userName = getNameById(carUserToken.userId);
                return (
                  <div key={carUserToken?.id} className={classes.tokenDetails}>
                    <span>Assign To:</span>
                    <span>{userName}</span>
                  </div>
                );
              }
            })}
          {/* {props?.occupiedToken?.id != 0 && (
            <div className={classes.tokenDetails}>
              <span>Token</span>
              <span>{props?.occupiedToken?.token?.displayValue}</span>
            </div>
          )} */}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default SummaryAssignedAllocations;
